function Home(props) {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_67_1126)">
        <path
          d="M18.5625 18.9686V10.3353C18.5625 10.2395 18.5425 10.1447 18.5037 10.0571C18.4649 9.96953 18.4083 9.89099 18.3373 9.82655L11.4623 3.33484C11.3358 3.21962 11.1707 3.15576 10.9996 3.15576C10.8284 3.15576 10.6634 3.21962 10.5368 3.33484L3.6618 9.82655C3.59105 9.89106 3.53455 9.96964 3.49592 10.0572C3.4573 10.1449 3.4374 10.2396 3.4375 10.3353V18.9686"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.375 18.9685H20.625"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0625 18.9685V14.156C13.0625 13.9737 12.9901 13.7988 12.8611 13.6699C12.7322 13.5409 12.5573 13.4685 12.375 13.4685H9.625C9.44266 13.4685 9.2678 13.5409 9.13886 13.6699C9.00993 13.7988 8.9375 13.9737 8.9375 14.156V18.9685"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_67_1126">
          <rect width="22" height="22" fill="white" transform="translate(0 0.406006)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Home;
